module.exports = __webpack_public_path__ + "media/images/goldsgym-9a87291a3ae4ba1669b1780474064dca.png";